<template>
  <div>
    <div
      id="modal-title"
      class="modal-header"
    >
      <h3>Identificar utente</h3>
    </div>
    <div class="modal-content">
      <p>Associe a senha a um utilizador através do seu Técnico ID.</p>
      <form
        id="form-create-user"
        action=""
        style="margin-top: 32px;"
      >
        <div class="input-group">
          <div class="input input-text">
            <label
              for="username"
              class="sr-only"
            >Utilizador</label>
            <div
              :disabled="unknown"
              :class="{ disabled : unknown}"
              style="position: relative;"
            >
              <input
                id="username"
                v-model="username"
                class="input-text--prefixed"
                type="number"
                placeholder="123456"
                required
              >
              <span class="input-text__prefix">
                ist
              </span>
            </div>
          </div>
        </div>

        <div
          v-if="currentUser && !unknown"
          class="label-user"
        >
          <div class="avatar">
            <img :src="currentUser.avatar">
          </div>
          <div class="">
            {{ currentUser.name }}
          </div>
          <div class="">
            {{ currentUser.username }}
          </div>
        </div>

        <div class="form-actions">
          <button
            type="button"
            class="btn-secondary"
            @click="close"
          >
            {{ $t('cancel') }}
          </button>
          <button
            :disabled="btnDisabled"
            type="button"
            class="btn-primary btn-active main-action"
            @click="assignUser()"
          >
            {{ $t('confirm') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import tickets from '@/api/tickets'

export default {
  name: 'AttendUser',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    serviceID: {
      type: String,
      required: true
    },
    ticket: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      open: false,
      username: null,
      timeout: null,
      unknown: false
    }
  },
  computed: {
    ...mapState(['currentTicket', 'currentUser']),
    btnDisabled () {
      if (this.currentUser && this.currentUser.username) {
        return false
      }
      return true
    }
  },
  watch: {
    username: function (newUsername, oldUsername) {
      if (this.timeout) {
        clearTimeout(this.timeout)
      }
      this.timeout = setTimeout(async () => {
        await this.fetchFenixUser({ username: `ist${newUsername}` })
      }, 800)
    }
  },
  created () {
    this.clearFenixUser()
  },
  beforeDestroy () {
    this.clearFenixUser()
  },
  methods: {
    ...mapActions(['fetchFenixUser', 'fetchCurrentTicket', 'clearFenixUser']),
    async close () {
      this.$emit('input', false)
    },
    async assignUser () {
      await tickets.assignUser({
        serviceID: this.serviceID,
        queueSlug: this.ticket.letter,
        ticketID: this.ticket.id,
        username: `ist${this.username}`
      })
      await this.fetchCurrentTicket(this.serviceID)
      this.close()
    }
  }
}
</script>
